// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"ErrorMessage_modalWrapper__20ESP","cardInfo":"ErrorMessage_cardInfo__3ZpYJ","message":"ErrorMessage_message__3-jjm","icon":"ErrorMessage_icon__tfLqL"};